import { CurrencyContext } from "@/modules/currency/CurrencyContext.tsx";
import type { CurrencyInfo } from "@/modules/currency/currencyInfo.ts";
import { notNull } from "@warrenio/utils/notNull";
import { useAtomValue } from "jotai/react";
import { useContext } from "react";

/** Get the currently selected currency info. Forced to the site currency in admin (to prevent confusion in pricing editors). */

export function useCurrentCurrency(): CurrencyInfo {
    const atom = notNull(useContext(CurrencyContext), "CurrencyContext");
    return useAtomValue(atom);
}
